import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import { setBreadcrumb } from 'state/actions/breadcrumb';
import { setActiveTab } from 'state/actions/tab';
import { fetchSessionDetails, exportSessionsById } from 'state/actions/session';
import { Button, Tabs, Spin } from 'antd';
import { ExportOutlined } from '@ant-design/icons';
import './index.css';
import InformationTab from './InformationTab';
import DataRecordedTab from './DataRecordedTab';

const { TabPane } = Tabs;

function SessionDetails() {
  const { id: sessionId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const { tab: activeTab } = useSelector((state) => state.tab);
  
  const { 
    sessionData, 
    loading,
    exporting, 
  } = useSelector((state) => ({
    sessionData: state.sessionAnalytic.currentSession,
    loading: state.sessionAnalytic.loading,
    exporting: state.sessionAnalytic.exporting || false,
  }));

  useEffect(() => {
    dispatch(
      setBreadcrumb([
        { menu: 'Session Analytics', link: '/session-analytics' },
        { menu: 'Session Details', link: `/session-analytics/${sessionId}` },
      ])
    );
    if (sessionId) {
      dispatch(fetchSessionDetails(sessionId));
    }
  }, [dispatch, sessionId]);

  useEffect(() => {
    return () => {
      dispatch(setActiveTab({ tab: 'sessionAnalytic' }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (activeTab !== 'informationSession' && activeTab !== 'dataRecorded') {
      dispatch(setActiveTab({ tab: 'informationSession' }));
    }
  }, [dispatch, activeTab]);


  const handleChangeTab = (activeKey) => {
    dispatch(setActiveTab({ tab: activeKey }));
  };
  
  const handleExportCSV = () => {
    if (!sessionId) return;
    dispatch(exportSessionsById([sessionId]));
  };

  const handleBack = () => {
    history.goBack();
  };

  if (loading && !sessionData) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!loading && !sessionData) {
     return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
            <h3>Session Not Found</h3>
            <p>The requested session could not be found.</p>
            <Button onClick={handleBack} className="btn-outline-primary">
              Back
            </Button>
        </div>
     );
  }

  return (
    <div className="siteinfo">
      <div className="siteinfo-nav p-20">
        <div>
          <h3 className="title">Session Details</h3>
        </div>
        <div style={{ display: 'flex', gap: '10px' }}>
          <Button
            className="btn-outline-primary"
            icon={<ExportOutlined />}
            onClick={handleExportCSV}
            style={{ width: '100%' }}
            disabled={exporting}
          >
            {exporting ? 'Exporting...' : 'Export CSV'}
          </Button>
          <Button onClick={handleBack} className="btn-outline-primary">
            Back
          </Button>
        </div>
      </div>

      <Tabs activeKey={activeTab} onChange={handleChangeTab}>
        <TabPane
          tab={<div className="siteinfo-tab"><span>Information</span></div>}
          key="informationSession"
        >
          <div className="tab-content">
          {activeTab === 'informationSession' && <InformationTab sessionData={sessionData} />}
          </div>
        </TabPane>
        <TabPane
          tab={<div className="siteinfo-tab"><span>Data Recorded</span></div>}
          key="dataRecorded"
        >
          <div className="tab-content">
            {activeTab === 'dataRecorded' && <DataRecordedTab sessionData={sessionData} />}
          </div>
        </TabPane>
      </Tabs>
    </div>
  );
}

export default SessionDetails;
